/*
|--------------------------------------------------------------------------
| ROUTES - Vue Router
|--------------------------------------------------------------------------
*/

import Vue from 'vue'
import Router from 'vue-router'

// Pages
import Home from '@/pages/Home'
import Page from '@/pages/Page'
import Post from '@/pages/Post'
import Search from '@/pages/Search'
import PageNotFound from '@/pages/PageNotFound'

// Register vue router
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // Static home page
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    // Static search page
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    // Dynamic WordPress page
    {
      path: '/:slug',
      name: 'Page',
      component: Page
    },
    // tatic WordPress post
    {
      path: '/actualites/:slug',
      name: 'Post',
      component: Post
    },
    // Other routes, no matching previous routes
    {
      path: '*',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js